/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createRouter, RouterProvider } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";

import { routeTree } from "./routeTree.gen";

import "./styles/index.css";

import * as Sentry from "@sentry/react";
import { PostHogProvider } from "posthog-js/react";

import { Button } from "./components/ui/button";
import { env } from "./env";

const options = {
  api_host: env.VITE_POSTHOG_HOST,
};

const handleReload = () => {
  window.location.href = "/";
};

// Set up a Router instance
const router = createRouter({
  routeTree,
  defaultPreload: "viewport",
  defaultErrorComponent: (e) => {
    Sentry.captureException(e);
    return (
      <div className="flex justify-center h-screen items-center flex-col gap-4 w-full">
        <div className="flex flex-col gap-2 items-center">
          <h1 className="text-4xl font-bold text-red-500">Error</h1>
          <p>Something went wrong....</p>
          <span className="text-xs italic">Please contact support.</span>
        </div>

        <Button onClick={handleReload}>Return to dashboard</Button>
      </div>
    );
  },
  defaultNotFoundComponent: () => (
    <div className="flex justify-center items-center flex-col gap-4 w-full">
      <div className="flex flex-col gap-2 items-center">
        <h1 className="text-4xl font-bold">Route error</h1>
        <p>The route you requested does not exist.</p>
      </div>
      <Button onClick={handleReload}>Return to dashboard</Button>
    </div>
  ),
});

Sentry.init({
  dsn: env.VITE_SENTRY_DSN,
  integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],

  tracesSampleRate: 1.0,
});

// Register things for typesafety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("app")!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <PostHogProvider apiKey={env.VITE_POSTHOG_KEY} options={options}>
      <RouterProvider router={router} />
    </PostHogProvider>,
  );
}
